import React, { useState, useEffect } from 'react'
import { TextField, Button, Grid } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { globalGetService } from '../../../utils/globalApiServices';
import { checkApiStatus } from '../../../utils';
import { useSnackbar } from 'notistack';

export default function AircraftFilters({ processingLoader, getResponseBack, setFilter, filter }) {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [maintenancePrograms, setMaintenancePrograms] = useState([])
    const [aircraftTypeList, setAircraftTypeList] = useState([])
    useEffect(() => {
        getAircraftTypeAPi()
    }, [])
    const changeGenericFilter = (key, value) => {
        if(value?.length <= 5){
            setFilter(prevState => ({
                ...prevState,
                [key]: value
            }))
        }
        else{
            enqueueSnackbar('Max 5 values can be selected.', {variant: 'error', anchorOrigin:{vertical: 'top',horizontal: 'right'}});
        }
        if (key == 'aircraft_type') {
            if (value[0] && value?.length == 1) {
                getMaintenancePrograms(value[0])
            }
            setMaintenancePrograms([])
            setFilter(prevState => ({
                ...prevState,
                maintenance_programs: []
            }))
        }
        else {

        }
    }
    const getAircraftTypeAPi = (query) => {
        globalGetService(`console/aircraft-types/`, {...query,'mr-calculator':'mr-calculator'})
            .then(response => {
                if (checkApiStatus(response)) {
                    setAircraftTypeList(response.data.data?.aircraftTypes)
                }
            })
    }
    const getMaintenancePrograms = (aircraftType) => {
        globalGetService(`console/aircraft-type/${aircraftType.id}/events/`, {'mr-calculator':'mr-calculator', list: true })
            .then(response => {
                if (checkApiStatus(response)) {
                    setMaintenancePrograms(response.data.data && response.data.data[0] ? response.data.data : []);
                }
            })
    }
    return (
        <div style={{ position: 'relative' }}>
            {processingLoader ?
                <div style={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '100%', zIndex: 10, background: 'rgba(255,255,255,.8)' }}>
                    <p style={{ textAlign: 'center', fontSize: '15px', padding: '7px 0' }}><span style={{ padding: '4px', background: '#fff', fontWeight: '500', fontFamily: 'Conv_IBMPlexSans-Medium' }}>Processing the Graph Data...</span></p>
                </div> : null
            }
            <Grid container spacing={1}  style={{ display: 'inline-flex', alignItems: 'center',padding:'' }}>
                <Grid item xs={12} md={6} lg={6}>
                    <Autocomplete
                        options={aircraftTypeList}
                        multiple
                        getOptionLabel={option => option.name}
                        value={filter?.aircraft_type || []}
                        id="aircraft_type"
                        onChange={(e, value) => changeGenericFilter('aircraft_type', value)}
                        renderInput={params => <TextField {...params} InputLabelProps={{ shrink: 'true' }} label="Aircraft Type" placeholder="Select Aircraft Type" variant="outlined" />}
                    />
                </Grid>
                <Grid item xs={12} md={6} lg={5}>
                    <Autocomplete
                        options={maintenancePrograms}
                        multiple
                        disabled={filter?.aircraft_type?.length > 1}
                        getOptionLabel={option => option.name}
                        value={filter?.maintenance_programs || []}
                        id="maintenance_programs"
                        onChange={(e, value) => changeGenericFilter('maintenance_programs', value)}
                        renderInput={params => <TextField {...params} InputLabelProps={{ shrink: 'true' }} label="Maintenance Program" placeholder="Select Maintenance Program" variant="outlined" />}
                    />
                </Grid>
                <Grid item xs={12} md={12} lg={1}>
                    <Button style={{padding:'10px',fontFamily:"Conv_IBMPlexSans-Medium",fontWeight:"600"}} fullWidth variant='contained' color='primary' size='small' onClick={()=> getResponseBack(filter)} >
                        Apply
                    </Button>
                </Grid>
            </Grid>
        </div>
    )
}
 